import { EditorState } from 'draft-js'
import { convertKanBoFormatToContentState } from 'components/RichText/utils/convert'
import getCharCountFromEditorState from './getCharCountFromEditorState'

export default (content) => {
  const editorState = EditorState.createWithContent(convertKanBoFormatToContentState(content))
  return getCharCountFromEditorState(editorState)
}
